__turbopack_context__.v({
  "backLink": "CaseStudies-module__tYV12W__backLink",
  "block": "CaseStudies-module__tYV12W__block",
  "blockTitle": "CaseStudies-module__tYV12W__blockTitle",
  "bullet": "CaseStudies-module__tYV12W__bullet",
  "bulletList": "CaseStudies-module__tYV12W__bulletList",
  "container": "CaseStudies-module__tYV12W__container",
  "ctaButton": "CaseStudies-module__tYV12W__ctaButton",
  "ctaPanel": "CaseStudies-module__tYV12W__ctaPanel",
  "ctaText": "CaseStudies-module__tYV12W__ctaText",
  "ctaTitle": "CaseStudies-module__tYV12W__ctaTitle",
  "disclaimer": "CaseStudies-module__tYV12W__disclaimer",
  "exampleBadge": "CaseStudies-module__tYV12W__exampleBadge",
  "factCard": "CaseStudies-module__tYV12W__factCard",
  "factGrid": "CaseStudies-module__tYV12W__factGrid",
  "factLabel": "CaseStudies-module__tYV12W__factLabel",
  "factValue": "CaseStudies-module__tYV12W__factValue",
  "gallery": "CaseStudies-module__tYV12W__gallery",
  "galleryCaption": "CaseStudies-module__tYV12W__galleryCaption",
  "galleryItem": "CaseStudies-module__tYV12W__galleryItem",
  "galleryMedia": "CaseStudies-module__tYV12W__galleryMedia",
  "galleryNote": "CaseStudies-module__tYV12W__galleryNote",
  "galleryTrigger": "CaseStudies-module__tYV12W__galleryTrigger",
  "galleryZoom": "CaseStudies-module__tYV12W__galleryZoom",
  "jumpIndex": "CaseStudies-module__tYV12W__jumpIndex",
  "jumpKicker": "CaseStudies-module__tYV12W__jumpKicker",
  "jumpMeta": "CaseStudies-module__tYV12W__jumpMeta",
  "lightbox-fade": "CaseStudies-module__tYV12W__lightbox-fade",
  "lightboxBackdrop": "CaseStudies-module__tYV12W__lightboxBackdrop",
  "lightboxCaption": "CaseStudies-module__tYV12W__lightboxCaption",
  "lightboxClose": "CaseStudies-module__tYV12W__lightboxClose",
  "lightboxFigure": "CaseStudies-module__tYV12W__lightboxFigure",
  "lightboxImage": "CaseStudies-module__tYV12W__lightboxImage",
  "lightboxNav": "CaseStudies-module__tYV12W__lightboxNav",
  "lightboxNext": "CaseStudies-module__tYV12W__lightboxNext",
  "lightboxPrev": "CaseStudies-module__tYV12W__lightboxPrev",
  "paragraph": "CaseStudies-module__tYV12W__paragraph",
  "previewBody": "CaseStudies-module__tYV12W__previewBody",
  "previewCard": "CaseStudies-module__tYV12W__previewCard",
  "previewGrid": "CaseStudies-module__tYV12W__previewGrid",
  "previewLink": "CaseStudies-module__tYV12W__previewLink",
  "previewMedia": "CaseStudies-module__tYV12W__previewMedia",
  "previewSummary": "CaseStudies-module__tYV12W__previewSummary",
  "previewTitle": "CaseStudies-module__tYV12W__previewTitle",
  "study": "CaseStudies-module__tYV12W__study",
});
